import { render, staticRenderFns } from "./modalUnidade.vue?vue&type=template&id=63d8bbc4&scoped=true&"
import script from "./modalUnidade.vue?vue&type=script&lang=js&"
export * from "./modalUnidade.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=63d8bbc4&scoped=true&lang=css&"
import style1 from "./modalUnidade.vue?vue&type=style&index=1&id=63d8bbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d8bbc4",
  null
  
)

export default component.exports